import React from 'react';
import { object, number, bool } from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Icon } from '@fiverr-private/fit';
import { r_check } from '@fiverr-private/fit/icons';
import { isRecurringOrderSelected } from '../../../../reducers/checkoutPlan';
import { getPackageById, getSelectedRecurringOption } from '../../../../reducers/packages';
import { translatePricingSummary } from '../../../../utils/recurring/translation';

import './style.scss';

const RecurringOptionsCol = (
    { currentPrice, selectedRecurringOption, isRecurringOrderSelected = false },
    { currencyConverter }
) => {
    const { duration, durationTimeUnit, discountPercentage } = selectedRecurringOption;

    const calculateFormattedPrice = () => {
        if (discountPercentage === 0) {
            return currencyConverter.convert(currentPrice);
        }

        const discount = discountPercentage / 100;
        const discountedPrice = currentPrice - (currentPrice * discount);

        return currencyConverter.convertWithFee(discountedPrice);
    };

    const formattedPrice = calculateFormattedPrice();
    const recurringPricingSummary = translatePricingSummary({
        formattedPrice, duration, durationTimeUnit
    });

    const wrapperClass = classNames(
        'recurring-options-col',
        { 'recurring-order': isRecurringOrderSelected }
    );

    return (
        <td className={wrapperClass}>
            <Icon size={14} className="selected-icon">
                {r_check}
            </Icon>
            {isRecurringOrderSelected && <p className="tbody-6">
                {recurringPricingSummary}
            </p>
            }
        </td>
    );
};

RecurringOptionsCol.propTypes = {
    currentPrice: number.isRequired,
    selectedRecurringOption: object.isRequired,
    isRecurringOrderSelected: bool
};

RecurringOptionsCol.contextTypes = {
    currencyConverter: object
};

const mapStateToProps = (state, { packageId }) => {
    const { packages } = state;
    const { currentPrice } = getPackageById(packages, packageId);
    const selectedRecurringOption = getSelectedRecurringOption(packages);

    return {
        currentPrice,
        selectedRecurringOption,
        isRecurringOrderSelected: isRecurringOrderSelected(state)
    };
};

export { RecurringOptionsCol };
export default connect(mapStateToProps)(RecurringOptionsCol);
